/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".fake-link[_ngcontent-%COMP%]{color:#636c72;font-weight:500}.fake-link[_ngcontent-%COMP%]:hover{text-decoration:underline;cursor:pointer}"];
export { styles as styles };
